import React, { Dispatch, SetStateAction } from 'react';
import {
  Control,
  FieldErrors,
  UseFormGetValues,
  UseFormHandleSubmit,
  UseFormReset,
  UseFormSetValue,
} from 'react-hook-form';

import { enterPress } from 'coreOld/utils';

import { FieldGroupWrapper, FieldWrapper } from './fieldChildStyle';

interface IProps<T> {
  child;
  handleSubmit?: UseFormHandleSubmit<T>;
  onSubmit?: (
    reset: UseFormReset<T>,
    setError: Dispatch<SetStateAction<string>>
  ) => (data: T) => void;
  control?: Control<T, object>;
  setValue?: UseFormSetValue<T>;
  getValues?: UseFormGetValues<T>;
  errors: FieldErrors<T>;
  reset?: UseFormReset<T>;
  setError?: Dispatch<SetStateAction<string>>;
}

const getFieldError = (errors, child) => {
  const { inputProps, props } = child;

  if (inputProps?.error) {
    return inputProps.error;
  }

  const { name } = props;

  const splittedName = name.split('[');
  if (splittedName.length > 1) {
    const [firstPart, secondPart] = splittedName;

    return errors?.[firstPart]?.[secondPart.replace(']', '')];
  }

  return errors?.[name];
};

const FieldChildView = <T,>({
  child,
  handleSubmit,
  onSubmit,
  control,
  setValue,
  getValues,
  errors,
  reset,
  setError,
}: IProps<T>) => {
  const getFieldInput = (child) =>
    React.createElement(child.type, {
      ...{
        ...child.props,
        inputProps: {
          ...child.props.inputProps,
          control,
          setValue,
          getValues,
          error: getFieldError(errors, child),
          hasBorder: false,
          onKeyDown: (e) => {
            if (child?.props?.inputProps?.onKeyDown) {
              child.props.inputProps.onKeyDown(e);
            }

            enterPress(e, handleSubmit(onSubmit(reset, setError)));
          },
        },
        key: child.props.name,
      },
    });

  if (child?.props?.children) {
    return (
      <FieldGroupWrapper>
        {React.Children.map(child?.props?.children, (insideChild) => (
          <FieldWrapper>{getFieldInput(insideChild)}</FieldWrapper>
        ))}
      </FieldGroupWrapper>
    );
  }

  return getFieldInput(child);
};

export default FieldChildView;
